import {
  between, integer, required, requiredIf, decimal, minValue, maxValue,
} from 'vuelidate/lib/validators';

const productForm = {
  basic: {
    name: {
      required,
    },
    description: {
      required,
    },
    cost: {
      required,
      decimal,
      minValue: minValue(1),
    },
    price: {
      required,
      decimal,
      minValue: minValue(1),
    },
    discount: {
      decimal,
      maxValue: maxValue(100),
    },
    vat: {
      required,
      between: between(1, 100),
      decimal,
    },
    weight: {
      required,
      decimal,
    },
  },
  catalog: {
    categoryId: {
      required,
      integer,
    },
  },
  outlet: {
    outletId: {
      // eslint-disable-next-line func-names
      required: requiredIf(function () {
        return this.action === 'edit';
      }),
    },
    quantity: {
      integer,
    },
  },
  attribute: {
    name: {
      required: requiredIf('groupIsSelected'),
    },
    price: {
      decimal,
    },
  },
  configuration: {
    daily_order_limit: {
      integer,
    },
    minimum_order: {
      integer,
    },
  },
};

export default productForm;
